<template>
  <el-dialog class="select-inform-people-dialog" title="通知范围" :visible.sync="data.visable" width="510px" center :close-on-click-modal="false">
    <div class="content">
      <div class="select-content" v-loading="loading">
        <!-- 搜索 群组 部门/人员 -->
        <div class="left">
          <div class="search">
            <el-input v-model="keywords" placeholder="搜索部门／人员／群组" prefix-icon="el-icon-search" clearable></el-input>
          </div>
          <div class="tabs">
            <div class="tab-title">
              <div :class="['dep', activeName === 'dep' && 'active']" @click="activeName = 'dep'">部门</div>
              <div :class="['group', activeName === 'group' && 'active']" @click="activeName = 'group'">群组</div>
            </div>
            <div class="tab-content">
              <div v-show="activeName === 'dep' && departments.length" class="dep-content">
                <el-tree ref="tree" :data="departments" :props="defaultProps" :indent="12" :expand-on-click-node="false" node-key="id">
                  <span class="custom-dep-tree" slot-scope="{ node, data }">
                    <span @click.stop="expandNode(node)" :class="getIconClass(node, data)"></span>
                    <span :class="['node-name', getShowCheck(data) && 'checked-name']" :style="{width: getWidth(node)}" :title="node.label" @click="nodeClick(data)">{{ node.label }}</span>
                    <span v-show="getShowCheck(data)" class="el-icon-check"></span>
                  </span>
                </el-tree>
                <!-- 搜索结果 -->
                <div v-if="keywords !== ''" class="result">
                  <div class="dep-result result-content">
                    <div class="title">部门</div>
                    <div class="list-content">
                      <el-tree
                        ref="resultTree"
                        :data="departments"
                        :props="defaultProps"
                        :indent="12"
                        :expand-on-click-node="false"
                        node-key="id"
                        :filter-node-method="filterNode">
                        <span class="custom-dep-tree" slot-scope="{ node, data }">
                          <span @click.stop="expandNode(node)" :class="getIconClass(node, data)"></span>
                          <span :class="['node-name', getShowCheck(data) && 'checked-name']" :style="{width: getWidth(node)}" :title="node.label" @click="nodeClick(data)">{{ node.label }}</span>
                          <span v-show="getShowCheck(data)" class="el-icon-check"></span>
                        </span>
                      </el-tree>
                    </div>
                  </div>
                  <div class="group-result result-content">
                    <div class="title">群组</div>
                    <div class="list-content">
                      <div :class="['group-item', getShowCheck(item) && 'active-item']" v-for="item in getFilterGroups" :key="item.id" @click="itemClick(item, 'group')">
                        <span class="el-icon-folder"></span>
                        <span class="group-name" :title="item.name">{{ item.name }}</span>
                        <span v-show="getShowCheck(item)" class="el-icon-check"></span>
                      </div>
                      <div v-if="getFilterGroups.length === 0" class="nothing-result">暂无数据</div>
                    </div>
                  </div>
                  <div class="person-result result-content">
                    <div class="title">人员</div>
                    <div class="list-content">
                      <div :class="['group-item', getShowCheck(item) && 'active-item']" v-for="item in getFilterPerson" :key="item.id" @click="itemClick(item, 'user')">
                        <span class="el-icon-folder"></span>
                        <span class="group-name" :title="item.name">{{ item.name }}</span>
                        <span v-show="getShowCheck(item)" class="el-icon-check"></span>
                      </div>
                      <div v-if="getFilterPerson.length === 0" class="nothing-result">暂无数据</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeName === 'group' && groups.length" class="group-content">
                <div :class="['group-item', getShowCheck(item) && 'active-item']" v-for="item in getFilterGroups" :key="item.id" @click="itemClick(item, 'group')">
                  <span class="el-icon-folder"></span>
                  <span class="group-name" :title="item.name">{{ item.name }}</span>
                  <span v-show="getShowCheck(item)" class="el-icon-check"></span>
                </div>
              </div>
              <div v-if="getShowNothing && !loading" class="nothing">暂无数据</div>
            </div>
          </div>
        </div>
        <!-- 选择区域 -->
        <div class="right">
          <div class="title">已选择的数据</div>
          <div class="selected-content" ref="selectedContent">
            <div class="select-item" v-for="item in selectedData" :key="item.id">
              <div class="select-item-content">
                <span :class="['el-icon-folder', item.type === 'user' && 'user-opacity']"></span>
                <span class="group-name" :title="item.name">{{ item.name }}</span>
                <span class="el-icon-error" @click.stop="delSelected(item)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="timing-button-primary" type="primary" @click="saveData">确 定</el-button>
      <el-button class="timing-button-default" @click="data.visable = false">取 消</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'select-inform-people',
  props: ['data'],
  data () {
    return {
      activeName: 'dep',
      groups: [],
      departments: [],
      selectedData: [],
      keywords: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      loading: true,
      allPerson: []
    }
  },
  async created () {
    await this.getGroups()
    await this.getAllPerson()
    this.departments = await this.getDepartments()
    if (this.data.data && this.data.data.length > 0) {
      this.selectedData = this.$_.cloneDeep(this.data.data)
    }
    this.$nextTick(() => { this.loading = false })
  },
  methods: {
    // 获取群组列表
    getGroups () {
      return this.$axios.get('/auth-api/roles').then(res => {
        this.groups = res.data || []
      })
    },
    // type：group  department  user
    itemClick (item, type) {
      let index = this.selectedData.findIndex(c => c.id === item.id)
      if (index === -1) {
        this.selectedData.push({id: item.id, name: item.name, type})
        this.scrollDown()
      } else {
        this.selectedData.splice(index, 1)
      }
    },
    nodeClick (data) {
      this.itemClick(data, data.type)
    },
    // 获取部门
    async getDepartments (userName = '') {
      return (await this.$axios.get(`/auth-api/departments/departmentMemberTree?userName=${userName}`)).data
    },
    delSelected (item) {
      let index = this.selectedData.findIndex(c => c.id === item.id)
      index !== -1 && this.selectedData.splice(index, 1)
    },
    expandNode (node) {
      node.expanded = !node.expanded
    },
    // 这个方法可以考虑封装个全局的？好多地方用
    scrollDown () {
      this.$nextTick(() => {
        let scroll = this.$refs.selectedContent
        if (scroll.scrollHeight > scroll.clientHeight) {
          scroll.scrollTop = scroll.scrollHeight - scroll.clientHeight
        }
      })
    },
    saveData () {
      this.$emit('getCandidate', this.selectedData)
    },
    getAllPerson () {
      return this.$axios.get('/auth-api/users/findAllUser').then(res => {
        this.allPerson = res.data
      })
    },
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    }
  },
  computed: {
    getShowNothing () {
      return !(this.activeName === 'dep' ? this.departments.length : this.getFilterGroups && this.getFilterGroups.length)
    },
    getShowCheck () {
      return item => this.selectedData.find(c => c.id === item.id)
    },
    getIconClass () {
      return (node, data) => {
        // 人员不需要图标
        if (data.type !== 'department') return 'dep-icon'
        // 是否展开 expanded
        // 子节点 childNodes
        let className = 'dep-icon '
        className += node.childNodes.length === 0 ? 'el-icon-folder' : node.expanded ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
        return className
      }
    },
    getWidth () {
      return node => {
        let width = 165 - ((node.level - 1) * 12)
        width = width <= 13 ? 13 : width
        return `${width}px`
      }
    },
    getFilterGroups () {
      return this.keywords ? this.groups.filter(c => c.name.indexOf(this.keywords) !== -1) : this.groups
    },
    getFilterPerson () {
      return this.keywords ? this.allPerson.filter(c => c.name.indexOf(this.keywords) !== -1) : this.allPerson
    }
  },
  watch: {
    keywords (val) {
      this.$nextTick(() => this.$refs.resultTree && this.$refs.resultTree.filter(val))
    }
  }
}
</script>

<style lang="scss">
.select-inform-people-dialog {
  .el-dialog--center {
    .el-dialog__body {
      padding: 12px 10px;
      & > .content {
        width: 488px;
        height: 480px;
        border: 1px solid #C2C3C4;
        border-radius: 4px;
        .select-content {
          display: flex;
          justify-content: space-between;
          align-content: center;
          width: 100%;
          height: 100%;
          padding: 12px 0;
          .left, .right {
            width: 244px;
          }
          .left {
            padding: 2px 0;
            border-right: 1px solid #C2C3C4;
            .search {
              padding: 0 14px;
            }
            .tabs {
              height: calc(100% - 30px);
              .tab-title {
                display: flex;
                align-content: center;
                justify-content: center;
                height: 28px;
                .dep, .group {
                  font-size: 12px;
                  width: 28px;
                  height: 28px;
                  line-height: 28px;
                  text-align: center;
                  cursor: pointer;
                }
                .dep {
                  margin-right: 30px;
                  position: relative;
                  &:before {
                    content: '';
                    display: inline-block;
                    width: 1px;
                    height: 16px;
                    position: absolute;
                    background-color: #C2C3C4;
                    top: 6px;
                    right: -17px;
                  }
                }
                .active {
                  border-bottom: 2px solid var(--primary, #54ABF1);
                  color: var(--primary, #54ABF1);
                  &:active {
                    color: var(--shade-1, #54abf2);
                  }
                }
              }
              .tab-content {
                height: calc(100% - 30px);
                width: 100%;
                position: relative;
                .nothing {
                  width: 100%;
                  height: 100%;
                  text-align: center;
                  line-height: 350px;
                  font-size: 12px;
                  position: absolute;
                  top: 0;
                  left: 0;
                  z-index: 16;
                  color: #2A2929;
                }
                .group-content, .dep-content {
                  padding-top: 10px;
                  height: 100%;
                  max-width: 500px;
                }
                .group-content {
                  position: relative;
                  overflow-y: auto;
                  .group-item {
                    height: 28px;
                    line-height: 28px;
                    cursor: pointer;
                    padding-left: 14px;
                    &:hover {
                      background-color: #ECF5FB;
                    }
                    .el-icon-folder {
                      color: #CBCBCB;
                    }
                    .group-name {
                      display: inline-block;
                      width: calc(100% - 48px);
                      font-size: 12px;
                      padding-left: 8px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      vertical-align: middle;
                      padding-bottom: 2px;
                      color: #2A2929;
                    }
                    .el-icon-check {
                      color: var(--primary, #54ABF1);
                    }
                  }
                  .active-item {
                    .group-name, .el-icon-check {
                      color: var(--primary, #54ABF1);
                    }
                  }
                }
                .dep-content {
                  height: 100%;
                  overflow-y: auto;
                }
              }
              .result {
                width: 100%;
                height: 100%;
                position: absolute;
                z-index: 15;
                left: 0;
                top: 0;
                background-color: #fff;
                overflow-y: auto;
                .result-content {
                  .title {
                    color: #B3B5B9;
                    font-size: 12px;
                    padding: 0 14px;
                    height: 28px;
                    line-height: 28px;
                  }
                  .list-content {
                    .group-item {
                      height: 28px;
                      line-height: 28px;
                      cursor: pointer;
                      padding-left: 14px;
                      &:hover {
                        background-color: #ECF5FB;
                      }
                      .el-icon-folder {
                        color: #CBCBCB;
                      }
                      .group-name {
                        display: inline-block;
                        width: calc(100% - 48px);
                        font-size: 12px;
                        padding-left: 8px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        vertical-align: middle;
                        padding-bottom: 2px;
                        color: #2A2929;
                      }
                      .el-icon-check {
                        color: #54ABF1;
                      }
                    }
                    .active-item {
                      .group-name, .el-icon-check {
                        color: #54ABF1;
                      }
                    }
                    .nothing-result {
                      height: 28px;
                      line-height: 28px;
                      text-align: center;
                      color: #2A2929;
                      font-size: 12px;
                    }
                    .el-tree__empty-block {
                      height: 28px;
                      line-height: 28px;
                      min-height: 28px;
                      .el-tree__empty-text {
                        color: #2A2929;
                        font-size: 12px;
                      }
                    }
                  }
                }
                .person-result {
                  .list-content {
                    .group-item {
                      .el-icon-folder {
                        opacity: 0;
                      }
                    }
                  }
                }
              }
            }
          }
          .right {
            padding: 2px 0;
            .title {
              color: #232323;
              font-size: 12px;
              text-align: center;
              height: 28px;
              line-height: 28px;
            }
            .selected-content {
              padding-top: 10px;
              overflow-y: auto;
              height: calc(100% - 30px);
              .select-item {
                height: 28px;
                line-height: 26px;
                cursor: pointer;
                .select-item-content {
                  padding: 0 14px;
                  .el-icon-folder {
                    color: #CBCBCB;
                  }
                  .user-opacity {
                    opacity: 0;
                  }
                  .group-name {
                    display: inline-block;
                    width: calc(100% - 48px);
                    font-size: 12px;
                    padding-left: 8px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    vertical-align: middle;
                    color: #2A2929;
                    padding-bottom: 2px;
                  }
                  .el-icon-error {
                    color: #CBCBCB;
                    display: none;
                    &:hover {
                      color: #EE5757;
                    }
                    &:active {
                      color: #f18180;
                    }
                  }
                }
                &:hover {
                  background-color: #ECF5FB;
                  .select-item-content {
                    .el-icon-error {
                      display: inline-block;
                    }
                  }
                }
              }
            }
          }
          .el-tree {
            .el-tree-node:focus>.el-tree-node__content {
              background-color: #ECF5FB;
            }
            .el-tree-node__content {
              &:hover {
                background-color: #ECF5FB;
              }
              .custom-dep-tree {
                padding-left: 14px;
                display: flex;
                align-items: center;
                height: 100%;
                .dep-icon {
                  color: #CBCBCB;
                  margin-right: 12px;
                  display: inline-block;
                  width: 14px;
                  height: 14px;
                  font-size: 16px;
                  margin-bottom: 3px;
                }
                .node-name {
                  color: #2A2929;
                  display: inline-block;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 12px;
                  height: 100%;
                  line-height: 26px;
                }
                .checked-name {
                  color:var(--primary, #54ABF1);
                }
                .el-icon-check {
                  color: var(--primary, #54ABF1);
                }
              }
            }
            .is-current {
              & > .el-tree-node__content {
                background-color: #ECF5FB;
              }
            }
            // 隐藏原有的展开图标
            .el-tree-node__content > .el-tree-node__expand-icon {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/system/select-inform-people.vue